export const CONTEXT = 'context';
export const TOKEN = 'token';
export const REFRESH_TOKEN = 'refreshToken';
export const MSAL_TOKEN = 'msal';
export const OLD_CONTEXT = 'oldContext';
